import { RouteConfig } from "vue-router";

export const Router: RouteConfig[] = [];

export const routes = {};
